import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../design-system/Button";
import { StatusBanner } from "../design-system/StatusBanner";
import { useTrackingRuntime } from "../features/tracking/TrackingRuntimeContext";
import type { ClientNoticeRecord } from "../offline/database";
import {
  dismissOfflineWritesRetiredNotice,
  observeOfflineWritesRetiredNotice,
} from "../offline/trackingStore";

export function OfflineWritesRetiredBanner() {
  const { t } = useTranslation("foundation");
  const { ownerId } = useTrackingRuntime();
  const [result, setResult] = useState<{
    ownerId: string;
    notice: ClientNoticeRecord | null;
  } | null>(null);

  useEffect(() => {
    if (ownerId === null) return;
    const subscription = observeOfflineWritesRetiredNotice(ownerId).subscribe({
      next: (notice) => {
        setResult({ ownerId, notice });
      },
      error: () => {
        setResult({ ownerId, notice: null });
      },
    });
    return () => {
      subscription.unsubscribe();
    };
  }, [ownerId]);

  const notice = result?.ownerId === ownerId ? result.notice : null;
  if (ownerId === null || notice === null) return null;

  return (
    <StatusBanner
      action={
        <Button onClick={() => void dismissOfflineWritesRetiredNotice(ownerId)} variant="secondary">
          {t("shell.dismissRetiredWritesNotice")}
        </Button>
      }
      description={t("shell.retiredWritesDescription", {
        count: notice.discardedMutationCount,
      })}
      label={t("shell.retiredWritesLabel")}
      title={t("shell.retiredWritesTitle")}
      tone="warning"
    />
  );
}
